import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {responseSelector} from '../utils/utils';
import {useAlerts} from '../ui/alert';
import {alertTypes} from '../utils/Alert';
import {log} from '../utils/logs';
import {EquipoCreateView} from './EquipoCreateView';
import {equipoCreateDuck, equipoCreateThunk} from './duck';
import {getUsuariosForSelectThunk} from '../oportunidades/duck';

export const EquipoCreate = ({history, token}) => {
  const dispatch = useDispatch();
  const {topAlert, submitAlert, setSubmitAlert} = useAlerts();

  const equipoCreate = useSelector(state => state.equipoCreate);
  const [nombre, setNombre] = useState('');
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(equipoCreate);

    if (error) {
      setSubmitAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(equipoCreateDuck.actions.clear());
    }

    if (data) {
      dispatch(equipoCreateDuck.actions.clear());

      setSubmitAlert({
        text: 'Equipo creado correctamente',
        type: alertTypes.success,
        closable: false,
      });

      history.push(`/equipos`);
    }
  }, [equipoCreate]);

  function submit() {
    let data = {
      userToken: token.raw,
      nombre,
      integrantes: usuarios,
    };

    log({'submit.data': data});

    dispatch(equipoCreateThunk(data));
  }

  return (
    <EquipoCreateView
      mode="create"
      history={history}
      equipoCreate={equipoCreate}
      submit={submit}
      submitAlert={submitAlert}
      topAlert={topAlert}
      nombre={nombre}
      setNombre={setNombre}
      usuarios={usuarios}
      setUsuarios={setUsuarios}
      token={token}
    />
  );
};
